import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accompagnement-entreprise-details',
  templateUrl: './accompagnement-entreprise-details.component.html',
  styleUrls: ['./accompagnement-entreprise-details.component.scss']
})
export class AccompagnementEntrepriseDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
